import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import HomeIcon from '@mui/icons-material/Home';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
// import BadgeIcon from '@mui/icons-material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
// import FilePresentIcon from '@mui/icons-material/FilePresent';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import { Link } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ProductionQuantityLimitsRoundedIcon from '@mui/icons-material/ProductionQuantityLimitsRounded';


export default function Menu() {

//  const{theme } = React.useState(true);
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250, bgcolor:"transparent",paddingRight: "0px", "& .MuiModal-root": { overflow: "hidden" },  }} role="presentation" onClick={toggleDrawer(false)} >
      <List sx={{marginTop:5}}>
       
          <ListItem  disablePadding sx={{margin:"10px 0px"}}>
            <ListItemButton>
              <ListItemIcon>
                <HomeIcon sx={{fontSize:28}}/>
              </ListItemIcon>
             
              <Link to={"/"} className='ld:text-lg text-md uppercase font-semibold'> Home  </Link>
            </ListItemButton>
          </ListItem>
          <ListItem  disablePadding sx={{margin:"10px 0px"}}>
            <ListItemButton>
              <ListItemIcon>
                <AccountBoxIcon/>
              </ListItemIcon>
             
              <Link to={"/about"} className='ld:text-lg text-md uppercase font-semibold'> About  </Link>
            </ListItemButton>
          </ListItem>
          <ListItem  disablePadding sx={{margin:"10px 0px"}}>
            <ListItemButton >
             
            <ListItemIcon sx={{opacity:100}}>
            {/* <FilePresentIcon/> */}
<ProductionQuantityLimitsRoundedIcon/>
            </ListItemIcon>
                
             
             
              <Link to={"/products"} className='ld:text-lg text-md uppercase font-semibold'> Products  </Link>
            </ListItemButton>
          </ListItem>
          <ListItem  disablePadding sx={{margin:"10px 0px"}}>
            <ListItemButton>
              <ListItemIcon>
                {/* <ProductionQuantityLimitsRoundedIcon/> */}
                {/* <BadgeIcon/> */}
                <PercentRoundedIcon/>
              </ListItemIcon>

             
              <Link to={"/quickQuotation"} className='ld:text-lg text-md uppercase font-semibold'> Quick Quotation  </Link>
            </ListItemButton>
          </ListItem>
          <ListItem  disablePadding sx={{margin:"10px 0px"}}>
            <ListItemButton>
              <ListItemIcon>
                <AlternateEmailIcon/>
              </ListItemIcon>
             
              <Link to={"/contact"} className='ld:text-lg text-md uppercase font-semibold'> Contact  </Link>
            </ListItemButton>
          </ListItem>
         
      
      </List>
      <Divider />
     
    </Box>
  );

  return (
    <div className='bg-transparent pr-0'>
      <Button onClick={toggleDrawer(true)}  sx={{bgcolor:"transparent"}}> { open ?     <CloseRoundedIcon sx={{fontSize:36 , bgcolor:"transparent"}} /> :  <MenuIcon sx={{fontSize:36 , bgcolor:"transparent"}} />}  </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}  sx={{  bgcolor:"transparent", paddingRight: "0px" }}>
        {DrawerList}
      </Drawer>
    </div>
  );
}